<template>
  <b-modal
    id="edit-floor-plan"
    size="lg"
    centered
    title="Add/Edit Floor Plan List"
  >
    <div class="container">
      <form id="edit-floor-plan-form" @submit.prevent="submit">
        <div class="row" style="text-align: left">
          <div class="col-md-6">
            <b-form-group
              label-cols-sm="4"
              label="Select Building"
              label-align-sm="left"
            >
              <div class="input-group">
                <b-form-select v-model="form.buildingId" :required="true">
                  <template v-slot:first>
                    <option :value="null" disabled>
                      -- Please select building --
                    </option>
                  </template>
                  <option
                    v-for="(selectOption, indexOpt) in buildingList"
                    :key="indexOpt"
                    :value="selectOption.id"
                  >
                    {{ selectOption.title.en }}
                  </option>
                </b-form-select>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group
              label-cols-sm="4"
              label="Select Floor"
              label-align-sm="left"
            >
              <div class="input-group">
                <b-form-select :required="true" v-model="form.attributeId">
                  <template v-slot:first>
                    <option :value="null" disabled>
                      -- Please select floor --
                    </option>
                  </template>
                  <option
                    v-for="(selectOption, indexOpt) in floorList"
                    :key="indexOpt"
                    :value="selectOption.id"
                  >
                    {{ selectOption.title.en }}
                  </option>
                </b-form-select>
              </div>
            </b-form-group>
          </div>
        </div>
        <hr />
        <div id="logo-section" class="flex-row">
          <div class="flex-col flex-1">
            <!-- <ImagesUpload
              :multiple="false"
              :requiredName="false"
              :images="[form.images]"
              size="lg"
              :subject="'Picture (Blue,Denim,Mazarine,Anil 1200x800 pixel , Ciela,Kara 950x650 pixel)'"
              :uploadImageErrorRequired="uploadImageError"
            ></ImagesUpload> -->
            <ImageUploadNew
              :dataImage="{ ...form.images }"
              :uploadSetting="{ ...uploadSetting }"
              :isRequired="false"
              :showError="uploadImageError"
              :maxFile="1"
              :subject="'Picture (Blue,Denim,Mazarine,Anil 1200x800 pixel , Ciela,Kara 950x650 pixel)'"
              :onFileUploaded="onFileUploaded"
            ></ImageUploadNew>
          </div>
        </div>
      </form>
    </div>
    <template slot="modal-footer" slot-scope="{ cancel }">
      <b-button
        size="sm"
        variant="primary"
        type="submit"
        form="edit-floor-plan-form"
        >Save</b-button
      >
      <b-button size="sm" variant="outline-danger" @click="cancel()"
        >Cancel</b-button
      >
    </template>
  </b-modal>
</template>

<script>
import ImageUploadNew from '@/components/ImageUploadNew'

export default {
  props: {
    projectID: Number,
    onFetchFloorsList: Function,
    onUpdateFloors: Function,
    onAddFloors: Function,
    attrBuildings: {
      type: Array,
      default: () => [],
    },
    attrFloors: {
      type: Array,
      default: () => [],
    },
    form: {
      type: Object,
      default: () => ({
        projectId: 0,
        buildingId: null,
        attributeId: null,
        images: {
          source: null,
          name: '',
        },
      }),
    },
  },
  components: {
    ImageUploadNew,
  },
  data: () => ({
    uploadImageError: false,
    uploadSetting: {
      showPreview: false,
      showDelete: true,
      showAlt: true,
    },
  }),
  methods: {
    submit(e) {
      if (!this.form.images.source) {
        this.uploadImageError = true
        return
      }

      this.uploadImageError = false
      e.preventDefault()
      const data = this.form
      const floorplanData = {
        projectId: data.projectId,
        buildingId: data.buildingId,
        attributeId: data.attributeId,
        images: {
          source: data.images.source,
          name: data.images.name,
        },
      }

      if (data.id) {
        this.onUpdateFloors({ id: data.id, floorplanData }).then((resp) => {
          this.onFetchFloorsList()
          this.$bvModal.hide('edit-floor-plan')
          this.$bvToast.toast(resp.message, {
            title: 'Update',
            autoHideDelay: 2000,
            appendToast: true,
            variant: 'success',
            toaster: 'b-toaster-bottom-right',
            solid: true,
          })
        })
      } else {
        this.onAddFloors(data).then((resp) => {
          this.onFetchFloorsList()
          this.$bvModal.hide('edit-floor-plan')
          this.$bvToast.toast(resp.message, {
            title: 'Add',
            autoHideDelay: 2000,
            appendToast: true,
            variant: 'success',
            toaster: 'b-toaster-bottom-right',
            solid: true,
          })
        })
      }
    },
    onFileUploaded($value) {
      this.form.images = $value
    },
  },
  computed: {
    buildingList() {
      return [...this.attrBuildings].sort(($first, $next) => {
        if ($first.orderNum > $next.orderNum) {
          return 1
        } else if ($first.orderNum < $next.orderNum) {
          return -1
        }

        return 0
      })
    },
    floorList() {
      return [...this.attrFloors].sort(($first, $next) => {
        if ($first.orderNum > $next.orderNum) {
          return 1
        } else if ($first.orderNum < $next.orderNum) {
          return -1
        }

        return 0
      })
    },
  },
}
</script>

<style scoped>
#sub-domain-result {
  font-size: 14px;
  color: #000;
}
</style>
